import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=098196f4&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/js/ckeditor/ckeditor.css?vue&type=style&index=0&id=098196f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098196f4",
  null
  
)

export default component.exports